import uniqBy from 'lodash/uniqBy';

import { IssueStatus, Project } from '@qality/common-model';

import StorageOfUniqueServices from './StorageOfUniqueServices';

export default {
  async getAllStatuses(): Promise<Array<IssueStatus>> {
    try {
      const statusesResponse = await StorageOfUniqueServices.get('API').request(
        {
          url: `/rest/api/2/status`,
          type: 'GET',
        }
      );

      const statusesArrayWithDuplicates: Array<IssueStatus> = JSON.parse(
        statusesResponse.body
      ).map((status) => {
        return {
          id: status.id,
          name: status.name,
          statusCategory: status.statusCategory,
        };
      });

      return uniqBy(statusesArrayWithDuplicates, 'name');
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        "Couldn't load issue statuses",
        'We encountered an error while loading issue statuses data, please try again.'
      );
      return [];
    }
  },

  async getAllStatusesForProjects(
    projectIds: Array<Project['id']>
  ): Promise<Array<IssueStatus>> {
    const promises = projectIds.map((projectId) => {
      return StorageOfUniqueServices.get('API').request({
        url: `/rest/api/2/project/${projectId}/statuses`,
        type: 'GET',
      });
    });

    const statuses = await Promise.all(promises).catch((e) => {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        "Couldn't load issue statuses",
        'We encountered an error while loading issue statuses data, please try again.'
      );
      return [];
    });

    const statusesArrayWithDuplicates = statuses
      .flat()
      .map((response) => {
        const issueTypesWithStatuses = JSON.parse(response.body);
        return issueTypesWithStatuses
          .map((issueType) => {
            return issueType.statuses.map((status) => {
              return {
                id: status.id,
                name: status.name,
                statusCategory: status.statusCategory,
              };
            });
          })
          .flat();
      })
      .flat();

    return uniqBy(statusesArrayWithDuplicates, 'name');
  },
};
